import {Route, Routes} from '@angular/router';
import {IUserType, MenuId} from './shared/services/auth.service';
import {StaffAction} from './shared/services/staff.service';

export interface AccessConfig {
  roles?: IUserType[];
  staffActions?: StaffAction[];
  keys?: MenuId[];
}

export interface AppRoute extends Route {
  data?: Route['data'] & {
    access?: AccessConfig;
  };
}

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => {
      return import('./auth/auth.routes').then(
        (m) => m.Auth_Routes
      );
    },
  },
  {
    path: 'base',
    loadChildren: () => {
      return import('./base/base.routes').then(
        (m) => m.Base_Routes
      );
    },
  },
  {path: '**', pathMatch: 'full', redirectTo: 'base'}
];
